import { render, staticRenderFns } from "./booking-clinic-list.vue?vue&type=template&id=bd97ffcc&"
import script from "./booking-clinic-list.vue?vue&type=script&lang=js&"
export * from "./booking-clinic-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports